import ColdLeads from './ColdLeads.component';

export default ColdLeads;